export default __webpack_public_path__ + "static/media/country.6788c7ac.png";